import React, { createContext, useContext, useState, useCallback } from 'react';
import { fetchSubscriptions } from '../services/subscriptionService';

const OrganizationContext = createContext();

export const OrganizationProvider = ({ children }) => {
    const [selectedOrg, setSelectedOrg] = useState(
        localStorage.getItem('selectedOrg') || null
    );

    const [subscriptions, setSubscriptions] = useState([]);

    const updateSelectedOrg = useCallback((orgId) => {
        setSelectedOrg(orgId);
        localStorage.setItem('selectedOrg', orgId);
    }, []);

    const refreshSubscriptions = useCallback(async () => {
        try {
            const accountGuid = localStorage.getItem('authSession')
                ? JSON.parse(localStorage.getItem('authSession')).accountGuid
                : null;

            if (!accountGuid) {
                console.error('No account GUID found.');
                return;
            }

            const subscriptionData = await fetchSubscriptions(accountGuid);
            const activeSubscriptions = subscriptionData.filter(
                (sub) => !sub.canceledAt
            );
            setSubscriptions(activeSubscriptions);

            const persistedOrg = localStorage.getItem('selectedOrg');

            const isCurrentOrgValid = activeSubscriptions.some(
                (sub) => sub.subscriptionGuid === selectedOrg
            );

            if (isCurrentOrgValid) {
                // If the current selection is valid, keep it
                updateSelectedOrg(selectedOrg);
            } else if (activeSubscriptions.length > 0) {
                // Otherwise, default to the first active subscription
                const defaultOrg = persistedOrg && activeSubscriptions.some(
                    (sub) => sub.subscriptionGuid === persistedOrg
                )
                    ? persistedOrg
                    : activeSubscriptions[0].subscriptionGuid;
                updateSelectedOrg(defaultOrg);
            } else {
                // If no active subscriptions remain, clear the selection
                updateSelectedOrg(null);
            }
        } catch (error) {
            console.error('Failed to refresh subscriptions:', error);
        }
    }, [selectedOrg, updateSelectedOrg]);

    return (
        <OrganizationContext.Provider
            value={{
                selectedOrg,
                updateSelectedOrg,
                subscriptions,
                refreshSubscriptions,
            }}
        >
            {children}
        </OrganizationContext.Provider>
    );
};

export const useOrganization = () => useContext(OrganizationContext);
